import { useEffect, useRef, memo } from "react";

function CryptocurrencyMarket({ theme }) {
  const container = useRef();

  useEffect(() => {
    if (!container.current || !theme) return;

    const timeout = setTimeout(() => {
      container.current.innerHTML = "";
      const script = document.createElement("script");
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-screener.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
      {
        "defaultColumn": "overview",
        "screener_type": "crypto_mkt",
        "displayCurrency": "USD",
        "colorTheme": "${theme}",
        "isTransparent": ${theme === "dark"},
        "locale": "en",
        "width": "100%",
        "height": 550,
        "showToolbar": true
      }`;
      if (container.current) {
        container.current.appendChild(script);
      }
    }, 0);
    return () => clearTimeout(timeout); // Clean up
  }, [theme]);
  return (
    <div
      className={`w-full mb-4 rounded-sm shadow-box-shadow border border-background-surface ${
        theme === "dark" ? "bg-[#1a1a1a]" : ""
      }`}
      ref={container}
    >
      <div className="tradingview-widget-container__widget"></div>
    </div>
  );
}

export default memo(CryptocurrencyMarket);
